import React, { Fragment, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CardSection, Button, Radio, Loader } from "cxa-components";
import messages from "components/messagesDescription";
import PropTypes from "prop-types";
import {
  setSelectedClaimTypeId,
  postClaimsNeedHelp,
  setSelectedQuestionTag,
  checkClaimReachLimit,
} from "actions/claimActionsPP";
import { reduxForm, Field } from "redux-form";
import { intlShape, injectIntl } from "react-intl";
import { clearClaimDetails } from "../../actions/claimActionsPP";
import withMatchMediaProps from "@hocs/with-match-media-props";
import UpArrow from "../common/ArrowUp";
import DownArrow from "../common/ArrowDown";
import classnames from "classnames";
import SelectClaimList from "./SelectClaimList";

const SelectClaim = props => {
  const {
    intl,
    history,
    claimClassifications,
    selectedCategory,
    setSelectedCategory,
    selectedClaim,
    setSelectedClaim,
    activePlanYear,
    activeClaimant,
    selectedDelegator,
    handleSubmit,
    submitting,
    submitSucceeded,
    getShortLivedToken,
    setDirty,
    showClaimsAsList,
    isNarrowScreen,
  } = props;

  const dispatch = useDispatch();

  const getClaimsQuestion = useSelector(state => state.claimsPP.needHelpQuestions);
  const isCPFEnabled = useSelector(state => state.claimsPP.isCPFEnabled);

  const loading = useSelector(state => state.claimsPP.isFetching);

  const getResultsClaims = useSelector(state => state.claimsPP.needHelpClaims);
  const selectedQuestionTag = useSelector(state => state.claimsPP.selectedQuestionTag);
  const selectedClaimant = useSelector(state => state.claimsPP.selectedClaimant);
  const claimNotes = useSelector(state => state.claimsPP.claimNotes);

  const [showHelpClaim, setShowHelpClaim] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [selectedValue, setSelectedValue] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const toggleHelpClaim = () => {
    setShowHelpClaim(!showHelpClaim);
    dispatch(setSelectedClaim(null));
    dispatch(setSelectedCategory(null));
    setDirty(true);
    !showHelpClaim &&
      window.scrollTo({
        top: 200,
        behavior: "smooth",
      });
  };

  // const claimNotesForDisplay = claimNotes
  //   ? intl.formatMessage({ id: claimNotes, defaultMessage: claimNotes })
  //   : <sup>*</sup>${intl.formatMessage(messages.claimNotesForDisplayDescription)};

  // const profileNoteForDisplay = intl.formatMessage({id: "noteContentProfile", defaultMessage: myProfileNote })
  const claimNotesForDisplay = intl.formatMessage({
    id: "config.claimNotes",
    defaultMessage: claimNotes,
  });

  const proceedClaimSubmission = async selectedDelegator => {
    dispatch(clearClaimDetails());

    if (selectedClaim.serviceProviderId) {
      return handleExternalClaimSubmission(selectedClaim);
    } else {
      const { claimantType, claimantId } = getClaimantInfo(selectedClaimant);

      const planId = activePlanYear;
      const claimItemId = selectedClaim.claimId;
      const params = { planId, claimItemId, claimantId, claimantType };
      const reachLimit = await dispatch(
        checkClaimReachLimit(selectedDelegator ? { ...params, selectedDelegator } : params)
      );
      if (reachLimit) {
        const text = intl.formatMessage({ ...messages.claims.reachLimitErrorDescription });
        if (window.confirm(text)) {
          return;
        }
      } else {
        redirectToClaimSubmission(selectedClaim, selectedDelegator, claimantType, claimantId);
      }
    }
  };

  const handleExternalClaimSubmission = selectedClaim => {
    const text = intl.formatMessage({ ...messages.claims.externalClaimConfirmation });
    if (window.confirm(text)) {
      getShortLivedToken().then(response => {
        const { body: { slToken } = {} } = response;
        if (!slToken) {
          return;
        }
        const url = `/sso/sp/submit-claim?serviceProviderId=${selectedClaim.serviceProviderId}&slToken=${slToken}&functionReferenceId=Submission&claimItemId=${selectedClaim.claimId}`;
        const wnd = window.open(url, "_blank");
        wnd.focus();
      });
    }
  };

  const getClaimantInfo = selectedClaimant => {
    if (!selectedClaimant) return { claimantType: "", claimantId: "" };
    const claimantArr = selectedClaimant.split("|");
    const claimantType = claimantArr.length > 0 ? claimantArr[0] : "";
    const claimantId = claimantArr.length > 1 ? claimantArr[1] : "";
    return { claimantType, claimantId };
  };

  const redirectToClaimSubmission = (
    selectedClaim,
    selectedDelegator,
    claimantType = "",
    claimantId = ""
  ) => {
    const queryParams =
      claimantId && claimantType ? `?claimantId=${claimantId}&claimantType=${claimantType}` : "";
    const url = selectedDelegator
      ? `/claims/submit/${selectedClaim.claimId}/${activePlanYear}/${selectedDelegator}${queryParams}`
      : `/claims/submit/${selectedClaim.claimId}/${activePlanYear}${queryParams}`;

    history.push(url);
  };

  let activeCategory = null;
  if (claimClassifications && selectedCategory) {
    claimClassifications.forEach(cla => {
      const selectedItem = cla.claimCategories.find(
        cat => cat.categoryName == selectedCategory.categoryName
      );
      if (selectedItem) {
        activeCategory = selectedItem;
      }
    });
  }

  const handleInputChange = event => {
    const value = event.target.value;
    setInputValue(value);

    setShowSuggestion(value !== "");
    const filteredSuggestions =
      getClaimsQuestion.claimTags &&
      getClaimsQuestion.claimTags.filter(suggestion =>
        suggestion.name.toLowerCase().includes(value.toLowerCase())
      );

    setSuggestions(filteredSuggestions);
    setDirty(true);
  };

  const [showSuggestion, setShowSuggestion] = React.useState(false);

  const handleSelectSuggestion = suggestion => {
    if (suggestion) {
      setInputValue(suggestion.name);
      dispatch(setSelectedQuestionTag(suggestion.tagId));
      setShowSuggestion(false);
      setSelectedValue(suggestion.name);
      setDirty(true);
    }
  };

  const [selectedTags, setSelectedTags] = React.useState({});

  const isButtonDisabled = () => {
    for (const question of getClaimsQuestion.claimQuestions) {
      const selectedTag = selectedTags[question.questionId];
      if (question.isMandatory && (!selectedTag || selectedTag.isMandatory === undefined)) {
        return true;
      }
    }
    if (selectedValue === "") {
      return true;
    }

    return false;
  };

  const handleTagChange = (questionId, selectedTag, isMandatory) => {
    const originalTag = selectedTag.split("-")[0];

    setSelectedTags(prevSelectedTags => ({
      ...prevSelectedTags,
      [questionId]: {
        questionId,
        tagValue: originalTag,
        isMandatory,
      },
    }));
    setDirty(true);
  };

  const renderTextInput = ({
    handleChange,
    controlledValue,
    meta: { touched, error },
    ...props
  }) => (
    <Fragment>
      <input {...props} name="selectedTagId" value={controlledValue} onChange={handleChange} />
      {touched && error && <div style={{ color: "red" }}>{error}</div>}
    </Fragment>
  );

  const renderRadioComponent = data => (
    <Radio
      key={data.claimId}
      className="claim-radio-class"
      checked={data.claimId == (selectedClaim && selectedClaim.claimId)}
      onClick={() => {
        dispatch(setSelectedClaim(data));
        dispatch(setSelectedClaimTypeId(data.claimId));
        setDirty(true);
      }}
    >
      <div className="claim-radio">
        <strong>
          {intl.formatMessage({ id: data.claimName, defaultMessage: data.claimName })}
        </strong>
      </div>
      <span>
        {isCPFEnabled && data.cpfContributable && (
          <span className="claim-label">
            <strong>{intl.formatMessage(messages.claims.cpfContributable)}</strong>
          </span>
        )}
        {data.isTaxable && (
          <span className="claim-label">
            <strong>{intl.formatMessage(messages.claims.taxable)}</strong>
          </span>
        )}
      </span>
    </Radio>
  );

  const showProceedButton =
    (showHelpClaim && selectedClaim) ||
    (selectedClaim && selectedCategory) ||
    (showClaimsAsList && selectedClaim);

  if (loading || getClaimsQuestion === null) return <Loader />;

  const handleSelectClaimCategory = cat => {
    return () => {
      dispatch(setSelectedCategory(cat));
      dispatch(setSelectedClaim(null));
      dispatch(setSelectedClaimTypeId(""));
      setDirty(true);
    };
  };

  return (
    <Fragment>
      {!showClaimsAsList ? (
        <div className="select-claim-container csp-side-menu">
          <CardSection>
            <div className="section-label">
              <strong>{intl.formatMessage(messages.claims.selectTheTypeOfClaim)}</strong>
            </div>
            {!showHelpClaim &&
              claimClassifications.map(cla => {
                let categoryRows = [];

                const mobileRows = isNarrowScreen ? 2 : 3;
                for (let i = 0; i < cla.claimCategories.length; i += mobileRows) {
                  categoryRows.push(cla.claimCategories.slice(i, i + mobileRows));
                }
                return (
                  <div key={cla.classificationName} style={{ maxWidth: "92vw" }}>
                    <div className="claim-classification-section">
                      {intl.formatMessage({
                        id: cla.classificationName,
                        defaultMessage: cla.classificationName,
                      })}
                    </div>
                    {categoryRows.map((row, index) => (
                      <div key={cla.classificationName + index} style={{ display: "flex" }}>
                        {row.map(cat => {
                          const componentCls = classnames(
                            "button--tiles",
                            "category-card",
                            "button--tiles--selectable",
                            {
                              "button--tiles--active category-card-active":
                                selectedCategory &&
                                selectedCategory.categoryName === cat.categoryName,
                            }
                          );
                          return (
                            <button
                              type="button"
                              key={cat.categoryName}
                              className={componentCls}
                              onClick={handleSelectClaimCategory(cat)}
                            >
                              <span>
                                {intl.formatMessage({
                                  id: cat.categoryName,
                                  defaultMessage: cat.categoryName,
                                })}
                              </span>
                              <br />
                              {cat.categoryName && <img src={cat.categoryImage} alt="" />}
                            </button>
                          );
                        })}
                      </div>
                    ))}
                  </div>
                );
              })}
          </CardSection>
          {getClaimsQuestion.enabledClaimNeedHelp && (
            <Fragment>
              <button
                className="link"
                onClick={toggleHelpClaim}
                style={{ display: "flex", marginTop: "15px" }}
              >
                <span style={{ fontSize: "1.125rem" }}>
                  <strong>{intl.formatMessage(messages.needHelp)}</strong>
                </span>
                <span style={{ marginLeft: "15px" }}>
                  {showHelpClaim ? (
                    <UpArrow width="16px" height="16px" />
                  ) : (
                    <DownArrow width="20px" height="20px" />
                  )}
                </span>
              </button>
              {!showHelpClaim ? (
                <p className="need-help-notes">{intl.formatMessage(messages.needHelpNotes)}</p>
              ) : (
                <form
                  autoComplete="off"
                  onSubmit={handleSubmit((values, dispatch, props) => {
                    const transformObj = {};
                    for (const key in values) {
                      if (values.hasOwnProperty(key)) {
                        const value = values[key];
                        const newValue = value.split("-")[0];
                        transformObj[key] = newValue;
                      }
                    }
                    return postClaimsNeedHelp(transformObj, dispatch, props, selectedQuestionTag);
                  })}
                >
                  <div>
                    <div style={{ margin: "20px 0" }}>
                      <p>
                        <strong>{intl.formatMessage(messages.needHelpQuestionSubmit)}</strong>
                      </p>
                      <Field
                        component={renderTextInput}
                        handleChange={e => handleInputChange(e)}
                        controlledValue={intl.formatMessage({
                          id: inputValue,
                          defaultMessage: inputValue,
                        })}
                        onFocus={() => setShowSuggestion(true)}
                        className="textfield textfield--boxed width-mobile-input"
                        placeholder={intl.formatMessage(messages.marketplace.searchCriteriaText)}
                        type="text"
                        disabled={!getClaimsQuestion.claimTags && !getClaimsQuestion.claimQuestions}
                      />
                      {submitSucceeded && getResultsClaims.length === 0 && (
                        <p>{intl.formatMessage(messages.needHelpDisabled)}</p>
                      )}

                      {showSuggestion && (
                        <ul className="search-ul">
                          {suggestions &&
                            suggestions.map((suggestion, index) => (
                              <li
                                aria-hidden="true"
                                className="search-claims-list"
                                key={suggestion.tagId}
                                onClick={() => handleSelectSuggestion(suggestion)}
                              >
                                {intl.formatMessage({
                                  id: suggestion.name,
                                  defaultMessage: suggestion.name,
                                })}
                              </li>
                            ))}
                        </ul>
                      )}

                      {getClaimsQuestion.claimTags && getClaimsQuestion.claimQuestions && (
                        <Fragment>
                          <p style={{ fontSize: "0.75rem", marginLeft: "10px" }}>
                            {intl.formatMessage(messages.needHelpSupport)}
                          </p>
                          <strong>{intl.formatMessage(messages.needHelpOptionalQuestions)}</strong>
                        </Fragment>
                      )}
                    </div>
                    {
                      <div>
                        <ul className="need-help-lists">
                          {getClaimsQuestion.claimQuestions &&
                            getClaimsQuestion.claimQuestions.map(question => (
                              <li key={question.questionId}>
                                <p>
                                  {intl.formatMessage({
                                    id: question.questionText,
                                    defaultMessage: question.questionText,
                                  })}
                                  {question.isMandatory ? (
                                    <span className="need-help-required">*</span>
                                  ) : (
                                    ""
                                  )}{" "}
                                </p>
                                <Field
                                  required={question.isMandatory}
                                  component="select"
                                  value={
                                    question.questionId ||
                                    selectedTags[question.questionId].tagValue
                                  }
                                  onChange={e =>
                                    handleTagChange(
                                      question.questionId,
                                      e.target.value,
                                      question.isMandatory
                                    )
                                  }
                                  name={`questionId${question.questionId}`}
                                >
                                  <option value=""></option>
                                  {question.questionTags.map((tag, i) => (
                                    <option key={i} value={`${tag.tags}-${i}`}>
                                      {intl.formatMessage({
                                        id: tag.category,
                                        defaultMessage: tag.category,
                                      })}
                                    </option>
                                  ))}
                                </Field>
                              </li>
                            ))}
                        </ul>
                        <div className="need-help-form">
                          <Button
                            style={{ width: "220px", margin: "20px 30px" }}
                            type="submit"
                            className="need-help-button"
                            submitting={submitting}
                            disabled={isButtonDisabled()}
                          >
                            {intl.formatMessage(messages.apply)}
                          </Button>
                        </div>
                      </div>
                    }
                  </div>
                </form>
              )}
              {showHelpClaim &&
                getResultsClaims &&
                getResultsClaims.map(result => {
                  return renderRadioComponent(result);
                })}
            </Fragment>
          )}
          {!showHelpClaim && activeCategory && (
            <CardSection>
              <div className="section-label">
                <strong>{intl.formatMessage(messages.claims.selectSpecificClaimType)}</strong>
              </div>
              {activeCategory.children
                .filter(x => x.claimants.includes(activeClaimant))
                .map(item => {
                  return renderRadioComponent(item);
                })}
            </CardSection>
          )}
          <CardSection>
            <div dangerouslySetInnerHTML={{ __html: claimNotesForDisplay }} />
          </CardSection>
        </div>
      ) : (
        <SelectClaimList
          claimClassifications={claimClassifications}
          setSelectedClaim={setSelectedClaim}
          selectedClaim={selectedClaim}
        />
      )}
      {showProceedButton && (
        <CardSection className="need-submit-button">
          <Button
            onClick={() => {
              setDirty(false);
              setTimeout(() => {
                proceedClaimSubmission(selectedDelegator);
              }, 200);
            }}
            className="claim-submit-btn"
          >
            <strong>{intl.formatMessage(messages.claims.proceed)}</strong>
          </Button>
        </CardSection>
      )}
    </Fragment>
  );
};
SelectClaim.propTypes = {
  history: PropTypes.func,
  handleSubmit: PropTypes.func,
  submitting: PropTypes.bool,
  intl: intlShape.isRequired,
  submitted: PropTypes.bool,
  error: PropTypes.string,
  claimClassifications: PropTypes.array,
  selectedCategory: PropTypes.object,
  setSelectedCategory: PropTypes.func,
  selectedClaim: PropTypes.object,
  setSelectedClaim: PropTypes.func,
  activePlanYear: PropTypes.string,
  activeClaimant: PropTypes.number,
  selectedDelegator: PropTypes.string,
  submitSucceeded: PropTypes.bool,
  getShortLivedToken: PropTypes.func,
  setDirty: PropTypes.func,
  showClaimsAsList: PropTypes.bool,
  isNarrowScreen: PropTypes.shape({
    maxWidth: PropTypes.number.isRequired,
  }).isRequired,
};

export default injectIntl(
  reduxForm({
    form: "selectClaimsForm",
  })(
    withMatchMediaProps({
      isNarrowScreen: {
        maxWidth: 680,
      },
    })(SelectClaim)
  )
);



// WEBPACK FOOTER //
// ./components/claim/SelectClaim.js